const platformAdmin = {
  search: 'Search',
  chat: 'Chat',
  drbfm: 'DRBFM',
  cad: 'CAD',

  本契約: 'Active contract',
  トライアル: 'Trial',
  停止中: 'Suspended',
  アーカイブ: 'Archived',
  '読み込みに失敗しました。': 'Could not load the data.',
  未確認: 'Not verified',
  'Microsoft認証が完了しませんでした。再度ログインしてください。':
    'Microsoft sign-in did not finish. Please sign in again.',
  '認証を確認できませんでした。再度ログインしてください。':
    'Could not verify authentication. Please sign in again.',
  'Entra IDの設定がありません。管理者に確認してください。':
    'Entra ID is not configured. Contact an administrator.',
  'AIONA 横断管理': 'AIONA Platform Admin',
  'Entra IDでログインしてください。': 'Sign in with Entra ID.',
  'Entra IDでログイン': 'Sign in with Entra ID',
  対象環境: 'Environment',
  読み込み中: 'Loading',
  ログアウト: 'Sign out',
  '環境設定を読み込み中…': 'Loading environment settings…',
  '対象環境:': 'Environment: ',
  'のアクセス権を確認中…': ' access is being checked…',
  管理メニュー: 'Administration menu',
  テナント: 'Tenants',
  新規トライアル: 'New trial',
  操作履歴: 'Operation history',
  'この環境では変更操作が許可されていません。': 'Changes are not permitted in this environment.',
  集計済み: 'Aggregation complete',
  集計が古いため利用件数は未確認です: 'Usage is not verified because the aggregation is stale',
  必要期間が未集計のため利用件数は未確認です:
    'Usage is not verified because the required period has not been aggregated',
  '／ 最終成功:': ' / Last successful run: ',
  '／ 集計対象末尾:': ' / Aggregated through: ',
  '機能別件数: 直近7日の監査イベント。利用人数: 直近7日の重複なしユーザー数。ユーザー別件数: 直近30日。':
    'Feature counts: audit events over 7 days. Active users: distinct users over 7 days. Per-user counts: 30 days.',
  テナント一覧: 'Tenants',
  'テナントがありません。': 'No tenants.',
  テナント名: 'Tenant name',
  状態: 'Status',
  期限: 'Expiration',
  直近7日の利用件数: 'Usage events over 7 days',
  件: ' events',
  '読み込み中…': 'Loading…',
  '／ 対象環境:': ' / Environment: ',
  '契約・担当者': 'Contract and contacts',
  '状態:': 'Status: ',
  '／ 期限:': ' / Expiration: ',
  '担当者:': 'Contact: ',
  '／ 営業:': ' / Sales: ',
  '主要機能の利用（直近7日）': 'Feature usage over 7 days',
  利用ユーザー: 'Active users',
  人: ' users',
  最近の動き: 'Recent activity',
  'ユーザー別利用（直近30日・監査ログ）': 'Per-user usage (30-day audit events)',
  ユーザー: 'User',
  利用件数: 'Event count',
  保存済みデータ: 'Stored data',
  チャット: 'Chat',
  'スレッド ／': ' threads / ',
  'メッセージ ／ DRBFM': ' messages / DRBFM ',
  'この環境は閲覧のみです。': 'This environment is read-only.',
  '記録がありません。': 'No records.',
  日時: 'Date and time',
  操作: 'Operation',
  結果: 'Result',
  管理者: 'Administrator',
  期限延長: 'Extend expiration',
  停止: 'Suspend',
  '再開（本契約）': 'Reactivate (active contract)',
  個別データ削除: 'Delete selected data',
  管理操作: 'Administrative operations',
  理由: 'Reason',
  チャット履歴: 'Chat history',
  'アップロード文書は対象外です。削除は元に戻せません。':
    'Uploaded documents are excluded. Deletion cannot be undone.',
  内容を確認: 'Review details',
  管理操作の確認: 'Confirm administrative operation',
  の確認: ' confirmation',
  '／ テナント:': ' / Tenant: ',
  '理由:': 'Reason: ',
  '期限:': 'Expiration: ',
  '削除対象:': 'Delete: ',
  キャンセル: 'Cancel',
  '実行中…': 'Running…',
  で実行: ' — execute',
  会社名: 'Company name',
  テナントコード: 'Tenant code',
  初期管理者メール: 'Initial administrator email',
  担当者メール: 'Contact email',
  CS担当メール: 'Customer success email',
  営業担当メール: 'Sales email',
  メモ: 'Notes',
  トライアル作成の確認: 'Confirm trial creation',
  '機能:': 'Features: ',
  なし: 'None',
  で作成: ' — create',
  '管理APIの環境設定が不正です。': 'The admin API environment configuration is invalid.',
  '現在の環境が設定されていません。': 'The current environment is not configured.',
  '選択環境と管理APIの環境が一致しません。':
    'The selected environment does not match the admin API.',
  デモ: 'Demo',
  本番: 'Production',
  検索: 'Search',
  アップロード: 'Upload',
  失敗: 'Failures',
  requestFailed:
    'Cannot access the admin API ({{status}}). Check authentication, permissions and connectivity for the selected environment.',
};
export default platformAdmin;
